import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=49c84f33&scoped=true"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=49c84f33&prod&scoped=true&lang=css&external"
import style1 from "./notice.vue?vue&type=style&index=1&id=49c84f33&prod&scoped=true&lang=css"
import style2 from "./notice.vue?vue&type=style&index=2&id=49c84f33&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c84f33",
  null
  
)

export default component.exports